// This context is provided by foundations-editor-ui.

import { createContext } from 'react';
export const defaultSandboxContext = {
  sandboxed: false
};
export const SandboxContext = /*#__PURE__*/createContext(defaultSandboxContext);
const {
  Consumer,
  Provider
} = SandboxContext;
export { Provider as SandboxContextProvider };
export { Consumer as SandboxContextConsumer };